import React, { Component } from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AnimateHeight from 'react-animate-height'
import Editor from '~components/Editor'
import * as styles from '~styles/components/dropdown.module.scss'
import * as editorStyles from '~styles/components/editor.module.scss'

class Dropdown extends Component {
  constructor () {
    super()

    this.state = {
      open: false
    }
  }

  toggleDropdown (e) {
    const open = this.state.open

    this.setState((state) => {
      return { open: !open }
    })
  }

  isOpen (e) {
    return this.state.open
  }

  render () {
    const height = this.isOpen() ? 'auto' : 0
    const toggle = this.isOpen() ? 'open' : 'closed'

    return (
      <div className={classNames(styles.dropdown, styles[toggle])}>
        <button type="button" className={classNames(styles.title)} onClick={this.toggleDropdown.bind(this)}>
          {this.props.title}
        </button>

        {this.props.links && (
          <AnimateHeight duration={300} height={height}>
            <div className={classNames(styles.content, editorStyles.editor)}>
              {this.props.links.map((link, index) => {
                const parent = link.page.contentfulparent
                const parentSlug = parent ? `${parent.slug}/` : ''

                return (
                  <div key={index}>
                    <Link to={`/${parentSlug}${link.page.slug}`}>
                      {link.title}
                    </Link>
                  </div>
                )
              })}
            </div>
          </AnimateHeight>
        )}

        {this.props.content && (
          <AnimateHeight duration={300} height={height}>
            <div className={classNames(styles.content)}>
              <Editor text={this.props.content} />
            </div>
          </AnimateHeight>
        )}
      </div>
    )
  }
}

Dropdown.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array,
  content: PropTypes.string
}

export default Dropdown
